<template>
  <div  v-if="consulta" class="func-53">
    <div class="func-53">
      <funcionalidade-header :titulo="'Pendências'" :customVoltar="false"></funcionalidade-header>
      <div id="detalhe-consulta">
        <el-row>
          <el-col :span="20">
            <div class="detalhes-card-interno">
              <span style="margin-bottom: 10px" class="text-g-bold">{{ funcionalidade.parametros.textos.tituloBoxPendenciaInstalarApp}}</span>
              <el-card class="detalhes-card">
                <span class="responsavel" v-if="(consulta.meeting.responsavelAtendimento.chaveUnica !== consulta.paciente.chaveUnica)">PACIENTE:</span>
                <span class="responsavel" v-else>PACIENTE E RESPONSÁVEL:</span>
                <span class="bold">{{consulta.paciente.nome}}</span>
                <span class="contatos" style="margin-top:5px">{{consulta.paciente.numeroContrato}} - {{getTipoUsuario(consulta.paciente.idTipoUsuario)}}</span>
              </el-card>
              <el-card class="detalhes-card" v-if="(consulta.meeting.responsavelAtendimento.chaveUnica !== consulta.paciente.chaveUnica)">
                <span class="responsavel">RESPONSÁVEL:</span>
                <span class="bold">{{consulta.meeting.responsavelAtendimento.nome}}</span>
                <span class="contatos" style="margin-top:5px"><svgIcone icone="Dash_whatsapp" :height="15" style="vertical-align: bottom;" :cor="'#CCCCCC'"/> {{consulta.meeting.responsavelAtendimento.contato.telefone}}</span>
                <span class="contatos" style="margin-top:5px"><svgIcone icone="icon_mini_email" :height="15" style="vertical-align: bottom;" :cor="'#CCCCCC'" /> {{consulta.meeting.responsavelAtendimento.contato.email}}</span>
              </el-card>
            </div>
            <div style="padding: 0 20px;">
              <el-row style="font-size: 16px">
                {{ funcionalidade.parametros.textos.textoInstrucoesPendenciaInstalarApp }}
              </el-row>
              <el-row style="margin-top: 20px;">
                <el-button class="button-resolver" @click="goToGooglePlay">DOWNLOAD ANDROID</el-button>
                <el-button class="button-resolver" @click="goToAppStore">DOWNLOAD IPHONE</el-button>
              </el-row>
              <el-row style="margin-top: 20px;">
                <el-col :span="24">
                  <el-card class="detalhes-card-pendencias">
                    <span class="bold">{{ funcionalidade.parametros.textos.tituloBoxDetalhePendencia }}</span>
                    <span class="contatos" style="font-size: 16px; margin-top: 15px;"><b>{{ consulta.meeting.responsavelAtendimento.nome }}</b> {{ funcionalidade.parametros.textos.textoBoxDetalhePendencia }}</span>
                    <el-button @click="share()" class="btn" style="margin-top:15px">
                      <inline-svg style="vertical-align: bottom; height: 15px; width: 15px" :src="require('@/assets/icons/Dash_share.svg')" />
                      COMPARTILHAR INSTRUÇÕES
                    </el-button>
                  </el-card>
                </el-col>
              </el-row>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <Func53Share v-if="showShare" @onCloseClick="showShare = false" :shareText="shareText" :nome="consulta.meeting.responsavelAtendimento.nome" :email="consulta.meeting.responsavelAtendimento.contato.email" />
  </div>
</template>
<script>
import FuncionalidadeHeader from '@/components/FuncionalidadeHeader/FuncionalidadeHeader.vue'
import { mapGetters, mapState } from 'vuex'
import InlineSvg from 'vue-inline-svg'
import Func53Share from '@/views/53/Share.vue'

export default {
  components: { Func53Share, InlineSvg, FuncionalidadeHeader },
  data () {
    return {
      consulta: null,
      showShare: false,
      shareText: '',
      sharePacieteResponsavel: ''
    }
  },
  computed: {
    ...mapState('SetupApp', ['apiFuncionalidade', 'funcionalidade']),
    ...mapGetters('SetupApp', ['aplicacao']),
    contatos () {
      return this.consulta.paciente.contatos
    }
  },
  methods: {
    htmlPacieteResposavel () {
      if (this.consulta.meeting.responsavelAtendimento.chaveUnica === this.consulta.paciente.chaveUnica) {
        this.sharePacieteResponsavel = `<b>Paciente e Responsável:</b><br/>
        ${this.consulta.paciente.nome}<br/>
        ${this.consulta.paciente.numeroContrato} - ${this.getTipoUsuario(this.consulta.paciente.idTipoUsuario)}<br/>`
      } else {
        this.sharePacieteResponsavel = `<b>Paciente:</b><br/>
        ${this.consulta.paciente.nome}<br/>
        ${this.consulta.paciente.numeroContrato} - ${this.getTipoUsuario(this.consulta.paciente.idTipoUsuario)}<br/><br/>
        <b>Responsável:</b><br/>
        ${this.consulta.meeting.responsavelAtendimento.nome}<br/>
        ${this.consulta.meeting.responsavelAtendimento.contato.telefone}<br/>
        ${this.consulta.meeting.responsavelAtendimento.contato.email}<br/>`
      }
    },
    share () {
      this.showShare = true
      this.htmlPacieteResposavel()
      this.shareText = `
        <p><b>Pendência: ${this.funcionalidade.parametros.textos.tituloBoxPendenciaInstalarApp}</b></p>
        ${this.sharePacieteResponsavel}<br/>
        <p>${this.funcionalidade.parametros.textos.textoInstrucoesPendenciaInstalarApp}</p>
        <p><b>Download Android:</b> ${this.aplicacao.textos.urlGooglePlay}</p>
        <p><b>Download iPhone:</b> ${this.aplicacao.textos.urlAppStore}</p>
      `
    },
    async getDetalhe () {
      const res = await this.apiFuncionalidade.detalheConsulta({
        payload: {
          idAgenda: this.$route.query.idAgenda
        }
      })
      this.consulta = res.data
    },
    getTipoUsuario (idTipoUsuario) {
      let tipoUsuario = ''
      switch (idTipoUsuario) {
        case 'T':
          tipoUsuario = 'Titular'
          break
        case 'D':
          tipoUsuario = 'Dependente'
          break
        case 'A':
          tipoUsuario = 'Agregado'
          break
      }
      return tipoUsuario
    },
    goToAppStore () {
      window.open(`${this.aplicacao.textos.urlAppStore}`)
    },
    goToGooglePlay () {
      window.open(`${this.aplicacao.textos.urlGooglePlay}`)
    },
    async init () {
      await this.getDetalhe()
    }
  },
  async created () {
    await this.init()
  }
}
</script>
<style>
#detalhe-consulta .detalhes-card-pendencias {
  background-color: #ecf6fc;
  border: none;
  border-radius: 6px;
  -webkit-box-shadow: none;
  box-shadow: none;
}
#detalhe-consulta .pendencia {
  display: block;
  font-size: 14px;
  padding: 10px 0;
}
.detalhes-card-interno {
  padding: 30px 20px 0 20px;
}
.bold {
  font-family: "Open Sans", SansSerif;
  color: #333333;
  opacity: 1;
  font-weight: 600;
  font-size: 16px;
}
.button-resolver {
  background-color: var(--cor-primaria-aplicacao);
  border-color: var(--cor-primaria-aplicacao);
  font-weight: 500;
  text-transform: none;
  font-size: 12px;
}
.responsavel {
  font-family: "Open Sans", SansSerif;
  color: #333333;
  opacity: 1;
  font-weight: 600;
  font-size: 11px;
  display: block;
  margin-bottom: 5px;
}
</style>
